import { TeamTab } from './teamTab';

require('./teamTab.scss');

export const myTeamTabComponent = {
  template: require('./teamTab.html'),
  controllerAs: 'ctrl',
  controller: TeamTab,
};
